import { useState } from 'react';
import styles from './ManagePage.module.css';

const STRIPE_PORTALS: Record<string, string> = {
  stripe_US_main: 'https://billing.stripe.com/p/login/eVqfZh5Ub0ve2g23Y4bAs00',
  stripe_US_main_update: 'https://billing.stripe.com/p/login/eVqfZh5Ub0ve2g23Y4bAs00',
  stripe_thrive: 'https://billing.stripe.com/p/login/6oUdRa3fwffC7n428Q4ZG00',
  stripe_thrive_update: 'https://billing.stripe.com/p/login/6oUdRa3fwffC7n428Q4ZG00',
};

export default function ManagePage() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isRedirecting, setIsRedirecting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [noAccount, setNoAccount] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = email.trim().toLowerCase();
    if (!trimmed) return;

    setIsLoading(true);
    setError(null);
    setNoAccount(false);
    setIsRedirecting(false);

    try {
      const response = await fetch('/api/manage/lookup', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: trimmed }),
      });

      if (!response.ok) {
        setError('Something went wrong. Please try again.');
        return;
      }

      const data = await response.json();
      const accountId = data.stripe_account_id;

      if (accountId && STRIPE_PORTALS[accountId]) {
        setIsRedirecting(true);
        setIsLoading(false);
        setTimeout(() => {
          window.location.href = STRIPE_PORTALS[accountId];
        }, 2000);
      } else if (accountId) {
        setError('Your account type is not yet supported for self-service management. Please contact support.');
        setIsLoading(false);
      } else {
        setNoAccount(true);
        setIsLoading(false);
      }
    } catch {
      setError('Something went wrong. Please try again.');
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.logo}>
          <img src="/logo-sq.png" alt="Peapil Health" className={styles.logoImage} />
        </div>
        <h2 className={styles.subtitle}>Manage Your Subscription</h2>
        <p className={styles.description}>
          Enter your email address to look up your account.
        </p>

        <form onSubmit={handleSubmit} className={styles.form}>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email address"
            className={styles.input}
            required
            disabled={isRedirecting}
          />
          <button type="submit" className={styles.button} disabled={isLoading || isRedirecting}>
            {isLoading ? 'Looking up...' : 'Manage My Subscription'}
          </button>
        </form>

        {error && (
          <div className={styles.errorMessage}>{error}</div>
        )}

        {noAccount && (
          <div className={styles.result}>
            <p className={styles.noAccount}>
              Your account is not found please contact: <a href="mailto:support@peapilhealth.com" className={styles.supportLink}>support@peapilhealth.com</a>
            </p>
          </div>
        )}

        {isRedirecting && (
          <div className={styles.redirecting}>
            <div className={styles.redirectSpinner}></div>
            <p>Account found! Redirecting you to manage your subscription...</p>
          </div>
        )}
      </div>
    </div>
  );
}
